import { render, staticRenderFns } from "./list.vue?vue&type=template&id=55049c75&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=55049c75&prod&scoped=true&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=55049c75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55049c75",
  null
  
)

export default component.exports